import * as React from 'react';
import PropTypes from 'prop-types';
import ButtonComponent from './button-component';

export default class ButtonContainer extends React.Component {
    static CONTEXT = {
        DANGER: ButtonComponent.CONTEXT.DANGER,
        DEFAULT: ButtonComponent.CONTEXT.DEFAULT,
        INFO: ButtonComponent.CONTEXT.INFO,
        LINK: ButtonComponent.CONTEXT.LINK,
        PRIMARY: ButtonComponent.CONTEXT.PRIMARY,
        SUCCESS: ButtonComponent.CONTEXT.SUCCESS,
        WARNING: ButtonComponent.CONTEXT.WARNING,
    }

    render() {
        return <ButtonComponent {...this.props} disabled={this.props.disabled || this.props.loading}/>;
    }
}

ButtonContainer.propTypes = {
    className: PropTypes.string,
    context: PropTypes.oneOf([
        ButtonComponent.CONTEXT.DANGER,
        ButtonContainer.CONTEXT.DEFAULT,
        ButtonContainer.CONTEXT.INFO,
        ButtonContainer.CONTEXT.LINK,
        ButtonContainer.CONTEXT.PRIMARY,
        ButtonContainer.CONTEXT.SUCCESS,
        ButtonContainer.CONTEXT.WARNING
    ]),
    disabled: PropTypes.bool,
    id: PropTypes.string,
    loading: PropTypes.bool,
    name: PropTypes.string,
    onClick: PropTypes.func,
    primary: PropTypes.bool,
    secondary: PropTypes.bool,
    tertiary: PropTypes.bool,
    required: PropTypes.bool,
    submit: PropTypes.bool,
    title: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/component/form/button/button-container.js